// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyAMmv2WXeHwvfiey3Z_CIY5kkY8GuGJiJQ",
  authDomain: "my-react-web-app-bmcg.firebaseapp.com",
  databaseURL: "https://my-react-web-app-bmcg.firebaseio.com",
  projectId: "my-react-web-app-bmcg",
  storageBucket: "my-react-web-app-bmcg.appspot.com",
  messagingSenderId: "239584429778",
  appId: "1:239584429778:web:4c621f4c154f0e38",
  measurementId: "G-TEG9EHGYRS"
};
  
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

   // Initialize Performance Monitoring and get a reference to the service
   var perf = firebase.performance();
